/**
 * <stock-message>: updates the in stock / out of stock message when the variant changes.
 * Listens for the `variant:change` event dispatched by <variant-picker>.
 */
class StockMessage extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    document.addEventListener('variant:change', this.#handleVariantChange, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  /** @param {Event} event */
  #handleVariantChange = (event) => {
    if (!(event instanceof CustomEvent) || !(event.target instanceof Element)) return;

    // Ignore pickers for other products on the page
    const picker = event.target.closest('variant-picker');
    if (picker instanceof HTMLElement && picker.dataset.productId !== this.dataset.productId) return;

    const message = this.querySelector('.stock-message');
    const text = this.querySelector('[data-stock-text]');
    if (!message || !(message instanceof HTMLElement) || !text) return;

    const inStock = Boolean(event.detail.variant.available);
    const { inStockMessage = '', outOfStockMessage = '', inStockColor, outOfStockColor } = this.dataset;
    const content = inStock ? inStockMessage : outOfStockMessage;

    message.classList.toggle('stock-message--in-stock', inStock);
    message.classList.toggle('stock-message--out-of-stock', !inStock);
    message.style.setProperty('--stock-message-color', (inStock ? inStockColor : outOfStockColor) ?? '');
    text.textContent = content;
    message.hidden = content === '';
  };
}

if (!customElements.get('stock-message')) {
  customElements.define('stock-message', StockMessage);
}
